<template>
  <transition appear name="fade">
    <div class="dialog">
      <div class="layer"></div>
      <div class="content">
        <h1>SELECT A PLAYLISTS</h1>
        <ul>
          <li v-for="playlist in playlists" :key="playlist.id">
            <button v-text="playlist.name" @click="addToPlaylist(playlist.id, playlist.owner.id)"></button>
          </li>
        </ul>
        <button class="cancel" @click="close()">Cancel</button>
        <button class="close" @click="close()"></button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TrackEmbedDialog',
  props: ['playlists', 'addToPlaylist', 'close']
}
</script>

<style scoped lang="scss">
@import '../../scss/variables';
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .layer {
    background: $black;
    opacity: 0.8;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .content {
    padding: 50px;
    background: #191919;
    color: #9e9e9e;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-height: 500px;
    overflow: auto;

    h1 {
      color: $white;
      line-height: 2em;
    }

    ul {
      margin-bottom: 20px;
      li {
        line-height: 2em;
        button {
          cursor: pointer;
          outline: none;
          background: none;
          border: 0;
          padding: 0;
          color: #9e9e9e;
          &:hover {
            color: $white;
          }
        }
      }
    }

    .cancel {
      cursor: pointer;
      border: 1px solid #9e9e9e;
      background: transparent;
      outline: none;
      border-radius: 1em;
      font-size: 17px;
      padding: 5px 50px;
      color: #00ce34;
      margin: 0 auto;
      display: block;
      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .close {
    cursor: pointer;
    border-color: transparent;
    outline: none;
    filter: invert(100%);
    background-color: transparent;
    background-size: cover;
    background-image: url('/static/images/close.svg');
    background-repeat: no-repeat;
    background-position: 50% 50%;
    width: 25px;
    height: 25px;
    position: fixed;
    top: 10px;
    right: 10px;
    transition: transform 0.3s $easeOutBack;
    filter: invert(100%);
    &:hover {
      transform: scale(1.1);
    }
    &:active {
      transform: scale(0.9);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TrackEmbed/dialog.vue